import { createActionTypes } from '../core';
import { NAME as name } from './constants';

const NAME = name.toUpperCase();

export const GET_USER_DATA = createActionTypes(`${NAME}/GET_USER_DATA`);
